import React from "react";
import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import {
  PaymentsToCoachesAction,
  getPacketContentForUser,
} from "src/store/Slices/Administrator/PaymentsToCoachesSlice";
import dayjs from "dayjs";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";
import { Button, Modal, Table } from "antd";

const PaymentsToCoaches = () => {
  const dispatch = useDispatch();
  const searchInput = useRef(null);
  const prevFiltersRef = useRef({});

  const items = [];

  const filterOptionsArr = [
    { label: "Фильрация", value: 0, index: undefined },
    {
      label: "По номеру",
      value: 1,
      index: "id",
      title: "Персональная тренировка",
    },
    { label: "По клиенту", value: 2, index: "user", title: "Пользователь" },
    {
      label: "По дате записи",
      value: 3,
      index: "docDate",
      title: "Дата записи",
    },
    { label: "По клубу", value: 4, index: "club", title: "Клуб" },
    {
      label: "По проведению",
      value: 5,
      index: "isCommit",
      title: "Проведено",
    },
    { label: "По оплате", value: 6, index: "isPay", title: "Оплачено" },
    { label: "По цене", value: 7, index: "price", title: "Цена" },
    { label: "По занятию", value: 8, index: "job", title: "Занятие" },
    { label: "По услуге", value: 9, index: "service", title: "Услуга" },
    { label: "По № набора", value: 10, index: "packId", title: "№ набора" },
    { label: "По оценке", value: 11, index: "userStar", title: "Оценка" },
  ];

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [PaymentsToCoachesInfo, setPaymentsToCoachesInfo] = useState();
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [fromValue, setFromValue] = useState("");
  const [toValue, setToValue] = useState("");
  const [dateFromValue, setDateFromValue] = useState("");
  const [dateToValue, setDateToValue] = useState("");
  const [employIdValue, setEmployIdValue] = useState("");
  const [trainerIdValue, setTrainerIdValue] = useState("");
  const [clubIdValue, setClubIdValue] = useState("");
  const [priceFromValue, setPriceFromValue] = useState("");
  const [priceToValue, setPriceToValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedPacket, setSelectedPacket] = useState(null);

  // STORE
  const PaymentsToCoachesList = useSelector(
    (state) => state.PaymentsToCoachesSlice.PaymentsToCoachesList,
  );
  const PaymentsToCoachesListLoading = useSelector(
    (state) => state.PaymentsToCoachesSlice.PaymentsToCoachesListLoading,
  );

  const PacketContentForUser = useSelector(
    (state) => state.PaymentsToCoachesSlice.PacketContentForUser,
  );

  const convertTableFiltersToState = (tableFilters) => {
    const filters = {};

    Object.entries(tableFilters).forEach(([key, value]) => {
      if (key === "employFio") {
        if (value === null) {
          filters.trainerIdValue = "";
        } else if (value || value[0]) {
          filters.trainerIdValue = value[0];
        }
      } else if (value && value[0] !== null && value[0] !== undefined) {
        if (key === "id") {
          filters.fromValue = value[0];
          filters.toValue = value[1];
        } else if (key === "price") {
          filters.priceFromValue = value[0];
          filters.priceToValue = value[1];
        } else if (key === "docDate") {
          filters.dateFromValue = value[0];
          filters.dateToValue = value[1];
        } else if (key === "employ") {
          filters.employIdValue = value[0];
        } else if (key === "club") {
          filters.clubIdValue = value[0];
        }
      }
    });

    return filters;
  };

  const createFiltersMap = (additionalFilters = {}, stateUpdates = {}) => {
    console.log(stateUpdates.trainerIdValue, trainerIdValue);
    const filterData = {
      "Id.From":
        stateUpdates.fromValue !== undefined
          ? stateUpdates.fromValue
          : fromValue,
      "Id.To":
        stateUpdates.toValue !== undefined ? stateUpdates.toValue : toValue,
      "price.From":
        stateUpdates.priceFromValue !== undefined
          ? stateUpdates.priceFromValue
          : priceFromValue,
      "price.To":
        stateUpdates.priceToValue !== undefined
          ? stateUpdates.priceToValue
          : priceToValue,
      "Date.From":
        stateUpdates.dateFromValue !== undefined
          ? stateUpdates.dateFromValue
          : dateFromValue,
      "Date.To":
        stateUpdates.dateToValue !== undefined
          ? stateUpdates.dateToValue
          : dateToValue,
      employId:
        stateUpdates.employIdValue !== undefined
          ? stateUpdates.employIdValue
          : employIdValue,
      clubId:
        stateUpdates.clubIdValue !== undefined
          ? stateUpdates.clubIdValue
          : clubIdValue,
      ...additionalFilters,
    };

    const trainerId =
      stateUpdates.trainerIdValue !== undefined
        ? stateUpdates.trainerIdValue
        : trainerIdValue;
    if (trainerId) {
      filterData.trainerId = trainerId;
    }

    const cleanedData = Object.fromEntries(
      Object.entries(filterData).filter(
        ([key, value]) => value !== undefined && value !== null && value !== "",
      ),
    );

    console.log("Созданные фильтры:", cleanedData);
    return new Map(Object.entries(cleanedData));
  };

  const handleChangeDate = (dateArr) => {
    if (dateArr && dateArr[0] && dateArr[1]) {
      const [from, to] = dateArr;
      setDateFrom(from);
      setDateTo(to);
      setDateFromValue(from);
      setDateToValue(to);

      const filters = createFiltersMap({
        "Date.From": from,
        "Date.To": to,
      });

      dispatch(
        PaymentsToCoachesAction({
          flag: "get",
          value: Object.fromEntries(filters),
        }),
      );
    } else {
      setDateFrom("");
      setDateTo("");
      setDateFromValue("");
      setDateToValue("");
      dispatch(PaymentsToCoachesAction({ flag: "get" }));
    }
  };

  const formattedPerTrRows = useMemo(() => {
    return PaymentsToCoachesList?.data?.value?.rows.map((item) => ({
      ...item,
      docDate: dayjs(item.docDate).format("YYYY-MM-DD"),
    }));
  }, [PaymentsToCoachesList]);

  const handleTableChange = (pagination, filters, sorter) => {
    console.log("Фильтры из таблицы:", filters);
    const tableFilterParams = {};

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value[0] !== null && value[0] !== undefined) {
        if (key === "id") {
          tableFilterParams["Id.From"] = value[0];
          tableFilterParams["Id.To"] = value[1];
        } else if (key === "price") {
          tableFilterParams["price.From"] = value[0];
          tableFilterParams["price.To"] = value[1];
        } else if (key === "docDate") {
          tableFilterParams["Date.From"] = value[0];
          tableFilterParams["Date.To"] = value[1];
        } else if (key === "employ") {
          tableFilterParams["employId"] = value[0];
        } else if (key === "employFio") {
          // if (value[0]) {
          tableFilterParams["trainerId"] = value[0];
          // }
        } else if (key === "club") {
          tableFilterParams["clubId"] = value[0];
        } else {
          tableFilterParams[key] = value[0];
        }
      }
    });

    const stateUpdates = convertTableFiltersToState(filters);

    Object.entries(stateUpdates).forEach(([key, value]) => {
      if (key === "fromValue") setFromValue(value);
      if (key === "toValue") setToValue(value);
      if (key === "priceFromValue") setPriceFromValue(value);
      if (key === "priceToValue") setPriceToValue(value);
      if (key === "dateFromValue") setDateFromValue(value);
      if (key === "dateToValue") setDateToValue(value);
      if (key === "employIdValue") setEmployIdValue(value);
      if (key === "trainerIdValue") setTrainerIdValue(value);
      if (key === "clubIdValue") setClubIdValue(value);
    });
    const allFilters = createFiltersMap(tableFilterParams, stateUpdates);
    const filterObj = Object.fromEntries(allFilters);

    const filtersChanged =
      JSON.stringify(prevFiltersRef.current) !== JSON.stringify(filterObj);
    const currentPage = filtersChanged ? 1 : pagination.current;

    setPage(currentPage);

    prevFiltersRef.current = filterObj;

    dispatch(
      PaymentsToCoachesAction({
        flag: "get",
        value: {
          count: pagination.pageSize,
          offset: pagination.pageSize * (currentPage - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...filterObj,
        },
      }),
    );
  };

  const clickOnAction = (element) => {
    setPaymentsToCoachesInfo(element);
  };

  const handlePaginationChange = (page, pageSize) => {
    const allFilters = createFiltersMap();
    const filterObj = Object.fromEntries(allFilters);

    dispatch(
      PaymentsToCoachesAction({
        flag: "get",
        value: {
          count: pageSize,
          offset: pageSize * (page - 1),
          ...filterObj,
        },
      }),
    );
    setPage(page);
    setPageSize(pageSize);
  };

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1);
    setPageSize(20);

    const allFilters = createFiltersMap();
    const filterObj = Object.fromEntries(allFilters);

    dispatch(
      PaymentsToCoachesAction({
        flag: "get",
        value: {
          [`${dataIndex}`]: selectedKeys[0],
          ...filterObj,
        },
      }),
    );
  };

  useEffect(() => {
    dispatch(PaymentsToCoachesAction({ flag: "get" }));
  }, []);

  const handlePacketColumnClick = (record) => {
    setSelectedPacket(record);
    setOpenModal(true);
    setLoading(true);

    const fromDate =
      dateFromValue || dayjs().subtract(1, "month").format("DD-MM-YYYY");
    const toDate = dateToValue || dayjs().format("DD-MM-YYYY");

    dispatch(
      getPacketContentForUser({
        flag: "get",
        value: {
          packid: record.id,
          "docDate.from": fromDate,
          "docDate.to": toDate,
        },
      }),
    ).finally(() => setLoading(false));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Не указано";
    return dayjs(dateString).format("DD.MM.YYYY");
  };

  return (
    <>
      {window.innerWidth >= 768 ? (
        <AdminTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={PaymentsToCoachesListLoading}
          onClickRowOne={(record) => {
            setPaymentsToCoachesInfo(record);
          }}
          onPacketColumnClick={handlePacketColumnClick}
          columns={PaymentsToCoachesList}
          rows={formattedPerTrRows}
          total={PaymentsToCoachesList?.data?.value?.totalCount}
          items={items}
          title={() => <TableTitle handleChangeDate={handleChangeDate} />}
        />
      ) : (
        <AntdMobileTable
          items={items}
          page={page}
          setPage={setPage}
          setPageSize={setPageSize}
          elementsList={PaymentsToCoachesList}
          elementsListLoading={PaymentsToCoachesListLoading}
          handlePaginationChange={handlePaginationChange}
          clickOnAction={clickOnAction}
          onChange={handleTableChange}
          filterOptionsArr={filterOptionsArr}
          searchInput={searchInput}
          onClickSearchItem={onClickSearchItem}
          onPacketColumnClick={handlePacketColumnClick}
        />
      )}

      <Modal
        title={
          <div style={{ textAlign: "center", fontSize: "20px" }}>
            Информация о пакете
          </div>
        }
        open={openModal}
        onCancel={() => setOpenModal(false)}
        width="90vh"
        footer={[
          <Button key="close" onClick={() => setOpenModal(false)}>
            Закрыть
          </Button>,
        ]}
      >
        {selectedPacket && (
          <div>
            <p style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
              <strong style={{ fontSize: "20px" }}>Наименование пакета:</strong>{" "}
              <p style={{ fontSize: "17px", paddingTop: "4px" }}>
                {selectedPacket.packetName || "Не указано"}
              </p>
            </p>
            <p style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
              <strong style={{ fontSize: "20px" }}>Период:</strong>{" "}
              <p style={{ fontSize: "17px", paddingTop: "4px" }}>
                {PacketContentForUser?.data?.value?.rows?.length > 0
                  ? (() => {
                      const rows = PacketContentForUser.data.value.rows;
                      const sortedRows = [...rows].sort(
                        (a, b) => new Date(a.docDate) - new Date(b.docDate),
                      );
                      const startDate = sortedRows[0].docDate;
                      const endDate = sortedRows[sortedRows.length - 1].docDate;

                      return `${formatDate(startDate)} - ${formatDate(endDate)}`;
                    })()
                  : "Не указано - Не указано"}
              </p>
            </p>
            <p style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
              <strong style={{ fontSize: "20px" }}>
                Кол-во тренировок по пакету:
              </strong>{" "}
              <p style={{ fontSize: "17px", paddingTop: "4px" }}>
                {selectedPacket.trainingsHappened || "Не указано"}
              </p>
            </p>

            <div style={{ marginTop: "20px" }}>
              <h3 style={{ marginBottom: "16px" }}>Список тренировок</h3>
              <Table
                dataSource={PacketContentForUser?.data?.value?.rows || []}
                columns={[
                  {
                    title: "Дата тренировки",
                    dataIndex: "docDate",
                    key: "docDate",
                    render: (date) => formatDate(date),
                    sorter: (a, b) => new Date(a.docDate) - new Date(b.docDate),
                  },
                  {
                    title: "Время",
                    dataIndex: "docDate",
                    key: "docDate",
                    render: (date) =>
                      dayjs(date).format("HH:MM:ss") || "Не указано",
                  },
                ]}
                pagination={{
                  pageSize: 10,
                  showSizeChanger: false,
                }}
                scroll={{ x: 600 }}
                loading={loading}
                size="small"
              />
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default PaymentsToCoaches;
